
import redirectURL from "../redirectURL";
import DatePicker from 'react-datepicker'
import Select from 'react-select';
import moment from "moment";
import { useRef, useState, useEffect } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import Loader from "./Loader";

const Filters = (props) => {

    var filterCardStyle1 = { height: "90%" };
    var filterCardStyleLeft = { height: "90%" };
    var filterCardStyle2 = { padding: '10px' };
    var mnFilterClass = { marginLeft: "0px", padding: "0px" };

    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [loader, setLoader] = useState(false)
    const [searchCity, setSearchCity] = useState({ label: 'All', value: 'all' });
    const [searchState, setSearchStates] = useState({ label: '', value: '' });
    const [searchTransporters, setSearchTransporters] = useState({ label: 'All', value: 'all' });
    const [searchConsigner, setSearchConsigner] = useState([{ label: 'All', value: 'all' }]);
    const [searchConsignee, setSearchConsignee] = useState([{ label: 'All', value: 'all' }]);
    const [searchConsigneeType, setSearchConsigneeType] = useState({ label: 'All', value: 'all' });
    const [searchPlantZone, setSearchPlantZone] = useState({ label: 'All', value: 'all' });
    const [searchValue, setSeachValue] = useState('');
    const [fo_Array, setFoArray] = useState([]);
    const [searchType, setSearchType] = useState({ label: "Vehicle", value: "truck_no" });
    const [startDate, setStartDate] = useState(new Date(moment.parseZone().subtract(10, "days")));
    const [endDate, setEndDate] = useState(new Date(moment.parseZone()));

    const customStyles = {
        valueContainer: (base) => ({
            ...base,
            maxHeight: "40px", // Set your desired height
            overflow: "hidden", // Hide overflowing selected options
        }),
    };

    const handleChange = (e) => {
        const raw = e.target.value;
        setSeachValue(raw); // Convert comma-separated string into an array
        const setOfFos = raw
            .split(/[\s,]+/)
            .map(item => item.trim())        // Remove extra spaces
            .filter(item => item.length);    // Remove empty entries
        setFoArray(setOfFos);
    };
    const getTruckConsignments = async (e) => {
        e.preventDefault();
        setLoader(true)
        let params = {
            searchtype: searchType?.value,
            searchnumber: fo_Array
        }
        if (props.user.role[0] == "DEALER")
            params["user_code"] = props.user.dealer_code ?? "EMPTY"
        else if (props.user.role[0] == "PLANT") {
            params["plant_codes"] = props.user.plant_codes ?? "EMPTY"
        }
        else if (props.user.role[0] == 'EXIM') {
            params["movement_type"] = { $in: ['Exports', 'Imports'] }
        }
        let url = ''
        if (window.location.pathname == "/active-FOs" || window.location.pathname == "/active-exim-FOs")
            url = "consignments/gateActiveFOSearchFilter"
        else if (window.location.pathname == "/delivered-FOs" || window.location.pathname == "/delivered-exim-FOs")
            url = "consignments/gateDeliveredFOSearchFilter"
        else if (window.location.pathname == "/all-FOs" || window.location.pathname == "/all-exim-FOs")
            url = "consignments/gateAllFOSearchFilter"
        await redirectURL.post(url, params)
            .then(resp => {
                props.fragmentData(resp, setLoader)
            })
            .catch(err => { console.log(err); setLoader(false) })
    }
    const onConfirm = () => {
        setShow(false);
        setTitle('')
        setType('default')
    };

    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };

    const resetSearch2 = (e) => {
        setLoader(true)
        setSearchCity({ label: 'All', value: 'all' })
        setSearchStates({ label: '', value: '' })
        setSearchTransporters({ label: 'All', value: 'all' })
        setSearchConsigner([{ label: 'All', value: 'all' }])
        setSearchConsignee([{ label: 'All', value: 'all' }])
        setSearchConsigneeType({ label: 'All', value: 'all' })
        setSearchPlantZone({ label: 'All', value: 'all' })
        setStartDate(new Date(moment.parseZone().subtract(10, "days")))
        setEndDate(new Date(moment.parseZone()))
        props.loadConsignmentsData(setLoader)
    }

    const resetSearch1 = (e) => {
        setLoader(true)
        setSeachValue('')
        setSearchType({ label: "Vehicle", value: "truck_no" })
        props.loadConsignmentsData(setLoader)
    }

    const onGetConsignments = async (event) => {
        let query = {}
        if (searchCity.value != '' && searchCity.value != 'all')
            query["consignee_city"] = searchCity.value
        if (startDate == '' || startDate == "NaN-NaN-NaN") {
            var sDate = "";
        }
        else {
            query["sdate"] = moment.parseZone(new Date(startDate)).format("YYYY-MM-DD")
        }
        if (endDate == '' || startDate == "NaN-NaN-NaN") {
            var eDate = "";
        }
        else {
            query["edate"] = moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
        }
        if (searchConsigner == null || searchConsigner[0]?.value == '' || searchConsigner[0]?.value == 'all') {
        }
        else {
            query["consigner_code"] = searchConsigner.map(e => e.value)
        }
        if (searchState.value != '') {
            query["consignee_state"] = searchState.value
        }
        if (searchTransporters.value != "" && searchTransporters.value != 'all') {
            query["transporter_name"] = searchTransporters.value
        }
        if (searchConsignee == null || searchConsignee?.value == '' || searchConsignee?.value == 'all') {

        }
        else {
            query["user_code"] = searchConsignee.value ?? ''
        }
        if (searchConsigneeType.value != '' && searchConsigneeType.value != 'all') {
            query["consignee_type"] = searchConsigneeType.value
        }
        if (searchPlantZone.value != '' && searchPlantZone.value != 'all') {
            query["consigner_zone"] = searchPlantZone.value
        }
        setLoader(true)
        if (props.user.role[0] == "DEALER")
            query["user_code"] = props.user.dealer_code ?? "EMPTY"
        else if (props.user.role[0] == "PLANT") {
            query["plant_codes"] = props.user.plant_codes ?? "EMPTY"
        }
        else if (props.user.role[0] == "TRANSPORTER") {
            query["transporter_code"] = props.user.transporter_code ?? "EMPTY"
        }
        else if (props.user.role[0] == 'EXIM') {
            query["movement_type"] = "Road"
        }
        let url = ''
        if (window.location.pathname == "/active-exim-FOs" || window.location.pathname == '/active-FOs')
            url = "consignments/filterConsignments"
        else if (window.location.pathname == "/delivered-exim-FOs" || window.location.pathname == '/delivered-FOs')
            url = "consignments/filterDeliveredConsignments"
        else if (window.location.pathname == "/all-exim-FOs" || window.location.pathname == '/all-FOs')
            url = "consignments/filterAllConsignments"
        await redirectURL.post(url, query)
            .then(resp => {
                props.fragmentData(resp, setLoader)
            })
            .catch(err => console.log(err))
    }


    




    return (
        <>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <Loader show={loader} />
            <div className={props.filterToggle ? "row" : "row"}>
                <div className={"col-xl-3 col-lg-3 "}>
                    <div className="card" style={filterCardStyleLeft}>
                        <div className="row card-body" style={{ padding: "10px 30px" }}>
                            <form className="row" onSubmit={getTruckConsignments}>
                                <div className="form-group col-xl-12 col-lg-12" style={{ marginBottom: "5px" }}>
                                    <label>Select Type  </label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={false}
                                        id="selectedFilter"
                                        value={searchType}
                                        onChange={e => setSearchType(e)}
                                        style={{ borderRadius: "0px" }}
                                        options={[
                                            { label: "Vehicle", value: "truck_no" },
                                            { label: "FO Number", value: "fo_number" },
                                        ]} required />
                                </div>
                                <div className="form-group col-xl-12 col-lg-12" style={{ marginBottom: "5px" }}>
                                    <label className="reason">Vehicle / FO Number</label>
                                    <input type="text" name="reason" autoComplete="off" class="form-control" id="inputTruckConsignment" value={searchValue} onChange={handleChange} required />
                                </div>
                                <div className="col-xl-12 col-lg-12" style={{ textAlign: "left" }}>
                                    <button type="submit" className="btn btn-success">Submit</button>&nbsp;
                                    <button type="button" className="btn btn-warning" onClick={resetSearch1}>Reset</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"col-xl-9 col-lg-9"}>
                    <div className="card" style={filterCardStyle1}>
                        <div className="row card-body" style={filterCardStyle2}>
                            <div className="row col-xl-12 col-lg-12" style={mnFilterClass}>
                                <div className="form-group col-xl-3 col-lg-3" style={{ marginBottom: "5px" }}>
                                    <label>Select Plant / WH </label>
                                    <Select placeholder={"Select "} closeMenuOnSelect={false}
                                        value={searchConsigner}
                                        isMulti={true}
                                        styles={customStyles}
                                        className="border-radius-0"
                                        onChange={e => setSearchConsigner(e)}
                                        style={{ borderRadius: "0px" }}
                                        options={props.consignersList}
                                        required />
                                </div>
                                <div className="form-group col-xl-3 col-lg-3" style={{ marginBottom: "5px" }}>
                                    <label>Plant Zone  </label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={false}
                                        id="selectedPlantZone"
                                        style={{ borderRadius: "0px" }}
                                        value={searchPlantZone}
                                        onChange={e => setSearchPlantZone(e)}
                                        options={props.filterPlantZones}
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-3 form-group" style={{ marginBottom: "5px" }}>
                                    <div className=""><label>Created From Date</label></div>
                                    <div className="">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            name="startDate"
                                            autoComplete="off"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-3 form-group" style={{ marginBottom: "5px" }}>
                                    <div className=""> <label>Created To Date</label></div>
                                    <div className="">
                                        <DatePicker
                                            selected={endDate}
                                            autoComplete="off"
                                            onChange={handleEndDateChange}
                                            name="endDate"
                                            dateFormat="dd/MM/yyyy"
                                            className="datepicker-custom"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row col-xl-12 col-lg-12" style={{ marginLeft: "0px", padding: "0px" }}>
                                <div className="form-group col-xl-3 col-lg-3" style={{ marginBottom: "5px" }}>
                                    <label>Customer </label>

                                    <Select
                                        className="border-radius-0"
                                        isMulti={false}
                                        id="consigneeCode"
                                        style={{ borderRadius: "0px" }}
                                        value={searchConsignee}
                                        onChange={e => setSearchConsignee(e)}
                                        options={props.user.role?.[0] === "DEALER"
                                            ? props.consigneesList?.filter(
                                                item => item.value === props.user.dealer_code
                                            )
                                            : props.consigneesList}
                                    />
                                </div>
                                <div className="form-group col-xl-3 col-lg-3" style={{ marginBottom: "5px" }}>
                                    <label>Customer City   </label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={false}
                                        id="selectedCity"
                                        style={{ borderRadius: "0px" }}
                                        value={searchCity}
                                        onChange={e => setSearchCity(e)}
                                        options={props.filterCities}
                                    />
                                </div>
                                <div className="form-group col-xl-3 col-lg-3" style={{ marginBottom: "5px" }}>
                                    <label>Transporter  </label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={false}
                                        id="selectedTransporter"
                                        style={{ borderRadius: "0px" }}
                                        value={searchTransporters}
                                        onChange={(e) => setSearchTransporters(e)}
                                        options={
                                            props.user.role?.[0] === "TRANSPORTER"
                                            ? props.filterTransporters?.filter(
                                                item => item.code === props.user.transporter_code
                                            )
                                            :
                                            props.filterTransporters}
                                    />
                                </div>
                                <div className="form-group col-xl-3 col-lg-3" style={{ marginBottom: "5px" }}>
                                    <label>Customer Type  </label>
                                    <Select
                                        className="border-radius-0"
                                        isMulti={false}
                                        id="selectedConsigneeType"
                                        style={{ borderRadius: "0px" }}
                                        value={searchConsigneeType}
                                        onChange={e => setSearchConsigneeType(e)}
                                        options={props.filterConsigneeTypes}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-12 col-lg-12" style={{ marginLeft: "0px" }}>
                                <button type="button" className="btn btn-success" onClick={onGetConsignments}>Submit</button>&nbsp;
                                <button type="button" className="btn btn-warning" onClick={resetSearch2}>Reset</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Filters
